define('commons/variables-validator',['jquery', 'commons/variables-regex-provider'], function($, regexProvider) {

    var VariablesValidator = function(variablesProvider) {
        this.variablesProvider = variablesProvider;
    };

    /**
     * A function that take a string as input, and looks for variables (string between {}) and compares them to the list of variables to find the ones
     * that are not in the list of allowed.
     * 
     * @return an empty array if no error is found, an array containing the matched variables in the input that were not in the list of authorized
     *         variables
     */
    VariablesValidator.prototype.validate = function(value, noExtra) {
        var errors = [];

        // Build the regex in the function because it is modified by each call to exec()
        var validationRegex = regexProvider.getValidationRegex();

        // result is the result of the matching
        var result;

        var found = false;

        var variables = this.variablesProvider.getVariables(noExtra);

        // Loop vars
        var i;
        var variablesLength = variables.length;
        while ((result = validationRegex.exec(value)) !== null) {
            for (i = 0; i < variablesLength; i++) {
                if (result[1] == variables[i].name) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                errors.push(result[1]);
            }
            found = false;
        }
        return errors;
    };

    return VariablesValidator;
});
